import { USER_ROLES } from "@/constants";
import { customerEmailSecurityRoutes } from "@/modules/PhishTitan/routes/customerRoutes";
import { customerSettingsRoutes } from "@/modules/Settings/routes/customerRoutes";
import { SAT_SERVICE } from "@/utils/services";
import { ARC_SERVICE } from "@/utils/services";
import { PHISHING_SIMULATION } from "@/utils/services";
import { SAT_SERVICE as SAT } from "@/utils/services";

const customerRoutes = [
  {
    path: "",
    name: "customer-resolver",
    component: () => import("@/views/Customer/CustomerResolver.vue"),
    meta: {
      authorize: [USER_ROLES.SYSTEM, USER_ROLES.MSP, USER_ROLES.CUSTOMER],
    },
  },
  {
    path: "dashboard",
    name: "customer-dashboard",
    component: () => import("@/modules/Dashboard/views/Customer/index.vue"),
  },
  {
    path: "report_manager",
    name: "customer-report_manager",
    component: () =>
      import("@/modules/ReportManager/views/customer/report-manager/report-manager.index.vue"),
    meta: {
      solutionId: SAT_SERVICE,
    },
  },
  {
    path: "security_awareness_training",
    name: "customer-security_awareness_training",
    component: () =>
      import("@/modules/SecurityAwarnessTraining/views/Customer/customer.index.vue"),
    redirect: {
      name: "customer-security_awareness_training-overview",
    },
    meta: {
      solutionId: SAT,
    },
    children: [
      {
        path: "overview",
        name: "customer-security_awareness_training-overview",
        component: () =>
          import("@/modules/SecurityAwarnessTraining/views/Customer/overview/overview.index.vue"),
      },
      {
        path: "overview/schedule_sat",
        name: "customer-security_awareness_training-overview-schedule_sat",
        component: () =>
          import("@/modules/SecurityAwarnessTraining/views/Customer/schedule-sat/schedule-sat.index.vue"),
      },
      {
        path: "sat_campaigns",
        name: "customer-security_awareness_training-sat_campaigns",
        component: () =>
          import("@/modules/SecurityAwarnessTraining/views/Customer/sat-campaigns/campaigns.index.vue"),
      },
      {
        path: "sat_campaigns/details",
        name: "customer-security_awareness_training-sat_campaigns-details",
        component: () =>
          import("@/modules/SecurityAwarnessTraining/views/Customer/campaign-details/campaign-details.index.vue"),
      },
      {
        path: "sat_campaigns/schedule_sat",
        name: "customer-security_awareness_training-sat_campaigns-schedule_sat",
        component: () =>
          import("@/modules/SecurityAwarnessTraining/views/Customer/schedule-sat/schedule-sat.index.vue"),
      },
      {
        path: "content_manager",
        name: "customer-security_awareness_training-content_manager",
        component: () =>
          import("@/modules/SecurityAwarnessTraining/views/Customer/content-manager/content-manager.index.vue"),
      },
    ],
  },
  {
    path: "license_usage",
    name: "customerUsageRoute",
    component: () => import("@/modules/Usage/views/Customer/index.vue"),
    redirect: {
      name: "customerUsageOverview",
    },
    children: [
      {
        path: "",
        name: "customerUsageOverview",
        component: () =>
          import("@/modules/Usage/views/Customer/Overview/index.vue"),
      },
    ],
  },
  {
    path: "email_archiving",
    name: "customer-arc_titan",
    component: () => import("@/modules/ArcTitan/Views/Common"),
    meta: {
      solutionId: ARC_SERVICE,
    },
  },
  {
    path: "phishing_simulation",
    name: "customer-phishing_simulation",
    component: () =>
      import("@/modules/PhishingSimulations/views/Customer/customer.index.vue"),
    redirect: {
      name: "customer-phishing_simulation-overview",
    },
    meta: {
      solutionId: PHISHING_SIMULATION,
    },
    children: [
      {
        path: "overview",
        name: "customer-phishing_simulation-overview",
        component: () =>
          import("@/modules/PhishingSimulations/views/Customer/overview-page/overview-page.index.vue"),
      },
      {
        path: "overview/create_campaign",
        name: "customer-phishing_simulation-overview-create_campaign",
        component: () =>
          import("@/modules/PhishingSimulations/views/Customer/create-campaign/create-campaign.index.vue"),
      },
      {
        path: "phishing_campaigns",
        name: "customer-phishing_simulation-phishing_campaigns",
        component: () =>
          import("@/modules/PhishingSimulations/views/Customer/phishing-campaigns/phishing-campaigns.index.vue"),
      },
      {
        path: "phishing_campaigns/create_campaign",
        name: "customer-phishing_simulation-phishing_campaigns-create_campaign",
        component: () =>
          import("@/modules/PhishingSimulations/views/Customer/create-campaign/create-campaign.index.vue"),
      },
      {
        path: "phishing_campaigns/campaign-overview",
        name: "customer-phishing_simulation-phishing_campaigns-campaign_overview",
        component: () =>
          import("@/modules/PhishingSimulations/views/Customer/campaign-details/campaign-details.index.vue"),
      },
    ],
  },
  ...customerEmailSecurityRoutes,
  ...customerSettingsRoutes,
];

export default customerRoutes;
